import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import { mailTypeOptions } from '../constants/mailTypes';

const SearchBox = ({ hook }) => {
	return (
		<SearchBarCenter>
			<div>
				<Input
					name='From date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
				<Input
					name='To date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
			</div>
			<div>
				<SelectInput
					multiple={false}
					color={Colors.darkBlue}
					name='Mailing Type'
					options={mailTypeOptions}
					width={130}
					onChange={hook.handleMailTypeChange}
					setSelected={hook.setSelectedMailType}
					selected={hook.selectedMailType}
				/>
				<SelectInput
					multiple={true}
					color={Colors.darkBlue}
					name='Mailing Name'
					options={hook.mailOptions}
					width={130}
					setSelected={hook.setSelectedMailOptions}
					selected={hook.selectedMailOptions}
				/>
			</div>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarCenter>
	);
};

export default SearchBox;
